import React, { FC } from 'react'
import { mainColors } from '../../assets/colors'
import LocationApplicationItem from '../../types/LocationApplicationItem'
import LocationApplicationTruncated from '../../types/LocationApplicationTruncated'

interface Props {
  cellContent: string;
  row: LocationApplicationTruncated | LocationApplicationItem | any;
}

const getStatusAndColor = (status: string, row: any) => {
  let statusTitle = ''
  let statusColor = ''
  switch (status) {
    case 'REJECTED':
      statusTitle = row.itemType && row.itemType.includes('Debarment') ? 'REJECTED' : 'FEEDBACK PROVIDED'
      statusColor = mainColors.feedbackRed
      break
    case 'DENIED':
    case 'CLOSED':
      statusTitle = status
      statusColor = mainColors.feedbackRed
      break
    case 'SUBMITTED':
      statusTitle = 'PENDING'
      statusColor = mainColors.ratingYellow
      break
    case 'APPROVED':
      statusTitle = status
      statusColor = mainColors.successGreen
      break
    default:
      statusTitle = status
      statusColor = mainColors.warningBlue
      break
  }

  return { title: statusTitle, backgroundColor: statusColor }
}

const Status: FC<Props> = ({ cellContent, row }: Props) => {
  // Determine which status to display based on the business logic
  let displayStatus = cellContent;

  // For denied/closed applications, always show the location application status
  if (row.status === 'DENIED' || row.status === 'CLOSED') {
    displayStatus = row.status;
  } else if (row.applicationType === 'residential' && row['12BedCertification']) {
    // For residential applications that need certification
    if (row.certificationStatus && row.certificationStatus !== 'APPROVED') {
      // Show certification status unless it's already approved
      displayStatus = row.certificationStatus;
    }
    // If certification is approved, fall through to show location application status
  }
  // For non-residential applications, always show location application status

  const status = getStatusAndColor(displayStatus, row)
  const width = displayStatus === 'REJECTED' && !(row.itemType && row.itemType.includes('Debarment')) ? 200 : 150
  return (
    <span style={{ display: 'inline-block', backgroundColor: status.backgroundColor, color: 'white', width, textAlign: 'center', marginTop: 5 }}>
      {status.title}
    </span>
  )
}

export default Status